/**
 * @module Components.CalendarColorDot
 *
 * The swatch shown beside a booking option's title, matching the accent bar the
 * calendar draws for sessions booked with it.
 * Shared by both booking-option lists (facility and coach).
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { calendarColorName } from "app/utils/calendarColors";

import styles from "./styles.module.scss";

type PropsDef = {
  color?: string | null;
  testId?: string;
};

export default function CalendarColorDot({ color, testId }: PropsDef) {
  const { t } = useTranslation();

  if (!color) {
    return null;
  }

  // A colour outside the palette has no name to translate — show the value
  // itself rather than an empty tooltip.
  const name = calendarColorName(color);

  const label = t("Calendar colour: {{name}}", { name: name ? t(name) : color });

  // role="img" + aria-label so screen readers announce the colour; `title`
  // stays as the mouse tooltip.
  return (
    <span
      className={styles.dot}
      style={{ backgroundColor: color }}
      role="img"
      aria-label={label}
      title={label}
      data-testid={testId}
    />
  );
}
